export default {
  NewUsernameFormField__CHECK_AVAILABILITY: "Check availability",
  NewUsernameFormField__TEXT_USERNAME_AVAILABLE: "Yes, it is available!",
  NewUsernameFormField__TEXT_USERNAME_ERRORED:
    "We are unable to process your request. Please try again.",
  NewUsernameFormField__TEXT_USERNAME_SERVICE_UNAVAILABLE:
    "Service unavailable at this time. Please try again.",
  NewUsernameFormField__TEXT_USERNAME_UNAVAILABLE: "Sorry, already taken.",
};
